export enum Resolution {
    RES_2K = '2k',
    RES_4K = '4k'
}
